import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from './styles';

const TextToExpertiseFamily = () => {
  const classes = useStyles();

  return (
    <>
      <Box>
        <Box className={classes.title}>DIVÓRCIOS</Box>
        <Box>
          <p className={classes.paragraph}>
            O fim de um relacionamento traz consigo uma série de situações que
            trazem a reboque a necessidade de aconselhamento jurídico
            qualificado e, a contratação de um especialista é fundamental para
            diminuir os impactos e resguardar direitos.
          </p>
          <p className={classes.paragraph}>
            Pensando nisto, visando superar os desafios proporcionados pelo
            divórcio, temos que olhar para os detalhes como bens comuns, e, em
            especial, dos filhos menores, que exige cuidado e responsabilidade.
          </p>
        </Box>
        <Box className={classes.title}>COMO POSSO ME DIVORCIAR?</Box>
        <Box>
          <p className={classes.paragraph}>
            Hoje a Lei brasileira exige que todo divórcio seja acompanhado por
            um Advogado, seja o divórcio realizado em Cartório ou perante a
            Justiça.
          </p>
          <p className={classes.paragraph}>
            Caso os cônjuges estejam em acordo, e não existam filhos menores
            e/ou incapazes, o divórcio poderá ser realizado em cartório, o que
            confere aos interessados uma forma rápida, prática e formal de por
            fim a uma relação.
          </p>
          <p className={classes.paragraph}>
            Assim, o primeiro passo para efetivar seu divórcio ou, até mesmo a
            dissolução de uma união estável é buscar a orientação jurídica de um
            profissional especializado em Direito das Famílias, que irá lhe
            aconselhar sobre seus direitos e deveres.
          </p>
        </Box>

        <Box className={classes.title}>
          E O QUE É COLOCADO EM DEBATE NO DIVÓRCIO E/OU UNIÃO ESTÁVEL?
        </Box>
        <Box>
          <p className={classes.paragraph}>
            Nestas ações, que visam por fim a um vínculo jurídico entre as
            partes, regra geral, são colocados em discussão 04 (quatro) pontos,
            porém, não se limitando a eles:
          </p>
          <ol className={classes.paragraph}>
            <li>Partilha de Bens</li>
            <li>Guarda de Filhos menores e/ou incapazes</li>
            <li>Regulamentação de Convivência dos filhos</li>
            <li>Pensão alimentícia para os filhos e/ou cônjuge.</li>
          </ol>
          <p className={classes.paragraph}>
            Seu caso será analisado de forma individual e será apresentada a
            melhor estratégia para encerrar seu relacionamento de forma segura e
            satisfatória.
          </p>
          <p className={classes.paragraph}>
            Se você pretende se separar e quer saber como fazer, entre em
            contato pelo WhatsApp e agende ainda hoje uma consultoria com um
            especialista.
          </p>
        </Box>

        <Box className={classes.title}>PENSÃO ALIMENTÍCIA</Box>
        <Box>
          <p className={classes.paragraph}>
            Dentro da definição de família que temos, existem duas maneiras de
            fixação de pensão alimentícia:
          </p>
          <ol className={classes.paragraph}>
            <li>pensão para os filhos e; </li>
            <li>pensão para o ex-cônjuge/companheiro.</li>
          </ol>
          <p className={classes.paragraph}>
            Na primeira hipótese, a legislação presume que os filhos têm que
            receber os alimentos para que possam ter direito à alimentação,
            saúde, moradia, vestuário, lazer, além de outras coisas que fazem
            parte das necessidades básicas de uma pessoa, pois tendo em vista a
            idade, não podem gerar renda para seu sustento.
          </p>
          <p className={classes.paragraph}>
            Na segunda situação, é necessário que haja a efetiva comprovação
            daquele ex-cônjuge que pede alimentos, por meio de provas e
            evidências, que ele (a) deixou de trabalhar para se dedicar aos
            cuidados da família e que, por este motivo, não consegue mais se
            inserir no mercado de trabalho.
          </p>
        </Box>

        <Box className={classes.title}>A PENSÃO ACABA AOS 18 ANOS?</Box>
        <Box>
          <p className={classes.paragraph}>Em regra, não!</p>
          <p className={classes.paragraph}>
            Isto porque atualmente os Tribunais entendem que a pensão
            alimentícia seguirá devida pelo responsável até os 24 (vinte e
            quatro) anos, desde que o alimentado esteja cursando cursos
            técnicos, pré-vestibular ou até mesmo faculdade.
          </p>
        </Box>

        <Box className={classes.title}>
          COMO FAZER PARA ME LIVRAR DA PENSÃO?
        </Box>
        <Box>
          <p className={classes.paragraph}>
            Para que a pessoa obrigada a prover alimentos seja liberada da
            obrigação, o interessado deverá buscar orientação jurídica de um
            Advogado especialista para requerer a exoneração da obrigação por
            meio judicial, caso contrário, continuará obrigado a prover
            alimentos, podendo, inclusive, ser preso se deixar de pagar a pensão
            por conta própria.
          </p>
        </Box>

        <Box className={classes.title}>
          O EX-CÔNJUGE RECEBE PENSÃO VITALÍCIA?
        </Box>
        <Box>
          <p className={classes.paragraph}>Em regra, não!</p>
          <p className={classes.paragraph}>
            Normalmente a pensão devida ao ex-cônjuge é temporária. É
            estabelecida em conformidade com as condições sociais e que
            normalmente receberia se trabalhando estivesse.
          </p>
          <p className={classes.paragraph}>
            A pensão ao ex-cônjuge deve ser estabelecida de maneira proporcional
            e transitória até que o beneficiário consiga se restabelecer e se
            recolocar no mercado de trabalho e se sustentar por conta própria.
          </p>
          <p className={classes.paragraph}>
            E será de forma vitalícia a partir do momento em que aquela pessoa
            não mais possui condições de se manter, quer seja pela idade
            avançada ou outra condição que lhe prive de realizar outras
            atividades.
          </p>
          <p className={classes.paragraph}>
            Se você busca por uma pensão justa e que atenda suas necessidades
            e/ou de seus filhos, entre em contato pelo WhatsApp agora mesmo e
            agende uma reunião para saber mais.
          </p>
        </Box>

        <Box className={classes.title}>GUARDA E CONVIVÊNCIA</Box>
        <Box>
          <p className={classes.paragraph}>
            A criança e ao adolescente é fundamental garantir seus direitos e um
            ambiente favorável a seu desenvolvimento.{' '}
          </p>
          <p className={classes.paragraph}>
            Em nosso ordenamento jurídico existem duas formas do pleno exercício
            da guarda: unilateral e compartilhada.
          </p>
          <p className={classes.paragraph}>
            A regra geral no Brasil para o exercício da guarda é a
            compartilhada. Nela, ambos os genitores exercem o poder de decisão e
            se responsabilizam em iguais medidas sobre os filhos menores durante
            seu poder familiar que se estende até os 18 (dezoito) anos.
          </p>
          <p className={classes.paragraph}>
            Por outro lado, existe a situação onde a guarda poderá ser exercida
            por apenas um dos genitores. Isso poderá ocorrer mediante acordo nos
            autos do processo ou se, no curso da ação houver comprovação que a
            guarda compartilhada poderá traduzir em risco para a integridade
            moral, física ou psíquica dos filhos.
          </p>

          <Typography variant="subtitle2" className={classes.subTitle}>
            MAS ENFIM, O QUE É GUARDA COMPARTILHADA?
          </Typography>
          <p className={classes.paragraph}>
            É importante destacar que a guarda compartilhada não é uma
            alternância de residência dos genitores.
          </p>
          <p className={classes.paragraph}>
            A criança irá conviver com seus genitores de forma que melhor atende
            suas necessidades, não se traduzindo, necessariamente, passar 15
            (quinze) dias na casa de um genitor e outros 15 (quinze) na casa do
            outro.
          </p>
          <p className={classes.paragraph}>
            A guarda compartilhada, é, portanto, a participação de igual forma,
            poder de decidir sobre questões de interesses dos filhos em igual
            proporção.
          </p>
          <p className={classes.paragraph}>
            Ah! Vale destacar que mesmo havendo a definição de guarda
            compartilhada, que é regra geral, não isenta o outro genitor da
            obrigação de prestar alimentos!
          </p>
          <p className={classes.paragraph}>
            Se você necessita de regularizar a guarda de seus filhos, entre já
            em contato comigo pelos meios disponíveis no site.
          </p>
        </Box>
      </Box>
    </>
  );
};

const TextToExpertiseSuccessions = () => {
  const classes = useStyles();
  return (
    <Box>
      <Box className={classes.title}>SUCESSÕES</Box>
      <Typography variant="subtitle2" className={classes.subTitle}>
        Inventário e Testamento
      </Typography>
      <p className={classes.paragraph}>
        O momento da morte de um familiar é sempre cercado de luto e incertezas.
      </p>
      <p className={classes.paragraph}>
        Não é incomum que haja conflitos entre familiares pelo patrimônio
        deixado pelo falecido.
      </p>
      <p className={classes.paragraph}>
        Para que os herdeiros sejam devidamente assessorados, é indispensável
        que seja acompanhado por um advogado especialista em sucessões.
      </p>
      <p className={classes.paragraph}>
        E, caso você precise de um advogado para realizar o inventário e redigir
        testamentos, entre já em contato pelos meios disponíveis e faça seu
        planejamento sucessório.
      </p>
    </Box>
  );
};

export { TextToExpertiseFamily, TextToExpertiseSuccessions };
